import { defineEffect } from '../../../core/effect';

/**
 * **LP の回復**（Issue #538）。LP が増えた。
 *
 * 開く: `recover`。**増えた側の LP の枠**（HUD）で数字が弾ける。
 * `at: { hud: 'life' }` は HUD の口（`stage.hud.life(player)`）を引くので、
 * **HUD を作り替えても演出は壊れない**（契約は「名前」。設計文書 §3.1）。
 */
const COLOR = '#7ae08a';

export default defineEffect({
  situation: 'recover',
  label: 'LP 回復',
  color: COLOR,
  sounds: () => [{ at: 0, name: 'life_up' }],

  opens({ payload }) {
    const value = payload?.data?.value;
    if (!Number.isFinite(value) || value <= 0) return null;
    return { ...payload, value, player: payload.data?.player ?? payload.player ?? 0 };
  },

  layers: [
    {
      id: 'burst',
      label: '弾ける光',
      part: 'glow',
      at: { hud: 'life', player: 0, else: { screen: [200, 200] } },
      props: { color: COLOR },
      tf: {
        scale: { keys: [{ ms: 0, value: 0.4 }, { ms: 220, value: 2.4, ease: 'ease_out' }] },
        opacity: { keys: [{ ms: 0, value: 0.95 }, { ms: 420, value: 0 }] },
      },
    },
    {
      id: 'value',
      label: '数字',
      part: 'text',
      parent: 'burst',
      props: { text: '+{value}', size: 110, color: '#fff', strokeColor: '#005a1e' },
      tf: {
        scale: { keys: [{ ms: 0, value: 0.5 }, { ms: 180, value: 0.34, ease: 'ease_out' }] },
        opacity: { keys: [{ ms: 0, value: 0 }, { ms: 100, value: 1 }, { ms: 560, value: 1 }, { ms: 720, value: 0 }] },
        y: { keys: [{ ms: 0, value: 0 }, { ms: 720, value: -90, ease: 'ease_out' }] },
      },
    },
  ],
}, 'recover_effect.js');
